import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { provideZoneChangeDetection } from '@angular/core';

void (async () => {
  try {
    await platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] });
  } catch (err) {
    console.error(err);
  }
})();
